import { Component } from 'vue';
import Modal from '../utils/Modal';

const DeleteModal = (): Component => import('@/shared/modals/DeleteModal.vue');
const ConfirmModal = (): Component => import('../modals/ConfirmModal.vue');
const ErrorModal = (): Component => import('../modals/ErrorModal.vue');
const MessageModal = (): Component => import('../modals/MessageModal.vue');

class Modals {
  confirm(title: string, body?: string, cancelLabel?: string, confirmLabel?: string): Promise<void> {
    return Modal.openAndWait<void>(ConfirmModal, { title, body, cancelLabel, confirmLabel });
  }

  confirmDelete(message: string, title?: string, cancelLabel?: string, confirmLabel?: string): Promise<void> {
    return Modal.openAndWait<void>(DeleteModal, { title, message, cancelLabel, confirmLabel });
  }

  error(message?: string): void {
    // eslint-disable-next-line no-console
    Modal.open(ErrorModal, { message }).catch(console.error);
  }

  message(message?: string): void {
    // eslint-disable-next-line no-console
    Modal.open(MessageModal, { message }).catch(console.error);
  }
}

export default new Modals();